import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryItemRequest, fetchInventoryItemRequestHistory } from "./thunk";

interface initialStateType {
  itemRequestList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  itemRequestList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryItemRequestSlice = createSlice({
  name: "InventoryItemRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryItemRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryItemRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.itemRequestList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryItemRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Network Error";
      })
      .addCase(fetchInventoryItemRequestHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryItemRequestHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.itemRequestList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryItemRequestHistory.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Item Request History List";
      });
  },
});

export default InventoryItemRequestSlice.reducer;
